<template>
  <div class="energyData">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- <div class="d-flex jc-center">
			<dv-decoration-10 class="dv-dec-10" />
			<div class="d-flex jc-center">
			  <dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
			  <div class="title">
				<span class="title-text">访客数据分析</span>
			  </div>
			  <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="decorationColor" />
			</div>
			<dv-decoration-10 class="dv-dec-10-s" />
		  </div> -->

        <dv-border-box-1
          style="width: 100%; height: auto"
          :color="['#0099FE', '#0099FE']"
        >
          <div style="padding: 20px 30px">
            <div style="display: flex; align-items: center; margin-left: 10px">
              <el-select
                v-model="xtype"
                size="mini"
                style="width: 70px; margin-right: 10px"
                @change="changeSeach1()"
              >
                <el-option label="日" value=""></el-option>
                <el-option label="月" value="month"></el-option>
                <el-option label="年" value="year"></el-option>
              </el-select>

              <el-date-picker
                v-show="xtype == ''"
                v-model="value2"
                size="mini"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                :editable="false"
              >
              </el-date-picker>

              <el-date-picker
                v-show="xtype == 'month'"
                v-model="value5"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                size="mini"
                :editable="false"
              >
              </el-date-picker>

              <div v-show="xtype == 'year'">
                <el-date-picker
                  type="year"
                  v-model="value6"
                  placeholder="选择年"
                  size="mini"
                  :editable="false"
                >
                </el-date-picker>
                <span>至</span>
                <el-date-picker
                  type="year"
                  v-model="value7"
                  placeholder="选择年"
                  size="mini"
                  :editable="false"
                >
                </el-date-picker>
              </div>
            </div>
            <div style="width: 100%; text-align: center; margin-top: 20px">
              <span class="title-text">收款数据</span>
            </div>

            <div class="line1">
              <div class="line1-item" ref="line">
                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 10px; text-align: left">波峰波谷图</div> -->
                  </div>

                  <div class="line1Echar1" ref="line1Echar1"></div>
                </dv-border-box-13>
              </div>
              <div class="line1-item">
                <dv-border-box-12 style="flex: 1; padding: 10px">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 20px; text-align: left">区域能耗</div> -->
                    <div
                      style="
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        margin-left: 50px;
                      "
                    ></div>
                  </div>
                  <div class="line1Echar2" ref="line1Echar2"></div>
                </dv-border-box-12>
              </div>

              <div class="line1-item">
                <dv-border-box-13 style="padding: 10px; height: 100%">
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <!-- <div style="margin-left: 20px; text-align: left">商铺时段能耗</div> -->
                    <div
                      style="margin-right: 10px; display: flex; align-items: center"
                    ></div>
                  </div>
                  <div class="line1Echar3" ref="line1Echar3"></div>
                </dv-border-box-13>
              </div>
            </div>

            <div style="width: 100%; text-align: center; margin-top: 20px">
              <span class="title-text">水费数据</span>
            </div>

            <div class="line1">
              <div class="line1-item" ref="line">
                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 10px; text-align: left">波峰波谷图</div> -->
                  </div>

                  <div class="line2Echar1" ref="line2Echar1"></div>
                </dv-border-box-13>
              </div>
              <div class="line1-item">
                <dv-border-box-12 style="flex: 1; padding: 10px">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 20px; text-align: left">区域能耗</div> -->
                    <div
                      style="
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        margin-left: 50px;
                      "
                    ></div>
                  </div>
                  <div class="line2Echar2" ref="line2Echar2"></div>
                </dv-border-box-12>
              </div>

              <div class="line1-item">
                <dv-border-box-13 style="padding: 10px; height: 100%">
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <!-- <div style="margin-left: 20px; text-align: left">商铺时段能耗</div> -->
                    <div
                      style="margin-right: 10px; display: flex; align-items: center"
                    ></div>
                  </div>
                  <div class="line2Echar3" ref="line2Echar3"></div>
                </dv-border-box-13>
              </div>
            </div>

            <div style="width: 100%; text-align: center; margin-top: 20px">
              <span class="title-text">电费数据</span>
            </div>

            <div class="line1">
              <div class="line1-item" ref="line">
                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 10px; text-align: left">波峰波谷图</div> -->
                  </div>

                  <div class="line5Echar1" ref="line5Echar1"></div>
                </dv-border-box-13>
              </div>
              <div class="line1-item">
                <dv-border-box-12 style="flex: 1; padding: 10px">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 20px; text-align: left">区域能耗</div> -->
                    <div
                      style="
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        margin-left: 50px;
                      "
                    ></div>
                  </div>
                  <div class="line5Echar2" ref="line5Echar2"></div>
                </dv-border-box-12>
              </div>

              <div class="line1-item">
                <dv-border-box-13 style="padding: 10px; height: 100%">
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <!-- <div style="margin-left: 20px; text-align: left">商铺时段能耗</div> -->
                    <div
                      style="margin-right: 10px; display: flex; align-items: center"
                    ></div>
                  </div>
                  <div class="line5Echar3" ref="line5Echar3"></div>
                </dv-border-box-13>
              </div>
            </div>

            <div style="width: 100%; text-align: center; margin-top: 20px">
              <span class="title-text">客流数据</span>
            </div>

            <div class="line1">
              <div class="line1-item" ref="line">
                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 10px; text-align: left">波峰波谷图</div> -->
                  </div>

                  <div class="line3Echar1" ref="line3Echar1"></div>
                </dv-border-box-13>
              </div>
              <div class="line1-item">
                <dv-border-box-12 style="flex: 1; padding: 10px">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 20px; text-align: left">区域能耗</div> -->
                    <div
                      style="
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        margin-left: 50px;
                      "
                    ></div>
                  </div>
                  <div class="line3Echar2" ref="line3Echar2"></div>
                </dv-border-box-12>
              </div>

              <div class="line1-item">
                <dv-border-box-13 style="padding: 10px; height: 100%">
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <!-- <div style="margin-left: 20px; text-align: left">商铺时段能耗</div> -->
                    <div
                      style="margin-right: 10px; display: flex; align-items: center"
                    ></div>
                  </div>
                  <div class="line3Echar3" ref="line3Echar3"></div>
                </dv-border-box-13>
              </div>
            </div>

            <div style="width: 100%; text-align: center; margin-top: 20px">
              <span class="title-text">停车数据</span>
            </div>

            <div class="line1">
              <div class="line1-item" ref="line">
                <dv-border-box-13 :style="'width:100%;padding:10px;height:100%;'">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 10px; text-align: left">波峰波谷图</div> -->
                  </div>

                  <div class="line4Echar1" ref="line4Echar1"></div>
                </dv-border-box-13>
              </div>
              <div class="line1-item">
                <dv-border-box-12 style="flex: 1; padding: 10px">
                  <div style="margin-top: 10px; display: flex">
                    <!-- <div style="margin-left: 20px; text-align: left">区域能耗</div> -->
                    <div
                      style="
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        margin-left: 50px;
                      "
                    ></div>
                  </div>
                  <div class="line4Echar2" ref="line4Echar2"></div>
                </dv-border-box-12>
              </div>

              <div class="line1-item">
                <dv-border-box-13 style="padding: 10px; height: 100%">
                  <div
                    style="
                      margin-top: 10px;
                      display: flex;
                      justify-content: space-between;
                    "
                  >
                    <!-- <div style="margin-left: 20px; text-align: left">商铺时段能耗</div> -->
                    <div
                      style="margin-right: 10px; display: flex; align-items: center"
                    ></div>
                  </div>
                  <div class="line4Echar3" ref="line4Echar3"></div>
                </dv-border-box-13>
              </div>
            </div>
          </div>
        </dv-border-box-1>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { formatTime1 } from "../../utils/index.js";
import ScaleBox from "vue2-scale-box";
var dayjs = require("dayjs");
export default {
  components: {
    ScaleBox,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      value5: "",
      value6: "",
      value7: "",
      allSum: "",
      yearRatio: "",
      linkRatio: "",
      monSum: 0,
      monA: 0,
      monB: 0,
      monC: 0,
      yearSum: 0,
      yearA: 0,
      yearB: 0,
      yearC: 0,
      daySum: 0,
      dayA: 0,
      dayB: 0,
      dayC: 0,
      config: {},
      xtype: "",
      queryDate1: [],

      queryDate3: [],
      queryDate4: [],
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      decorationColor: ["#568aea", "#000000"],
      lineWidth: 0,
    };
  },
  created() {},
  mounted() {
    this.cancelLoading();
    setTimeout(() => {
      this.lineWidth = this.$refs.line.offsetWidth;
      this.changeSeach1();
      // this.changeSeach2();
      // this.setline1Echar3();
    }, 500);
    window.addEventListener("resize", () => this.Refresh());
    window.addEventListener("setItem", () => {});
  },
  beforeDestroy() {
    clearInterval(this.timing);
    // 销毁
    window.removeEventListener("resize");
  },
  methods: {
    changeSeach1() {
      //   this.$http
      //     .post(`/api/bdVisitApply/queryWebVisitApplyData`, {
      // 		xtype: this.xtype,
      //     })
      //     .then((res) => {
      //       if (res.data.code == 0) {
      //         res.data.data.list.forEach((element) => {
      //           xArr.push(element.xValue);
      //           yArr.push(element.yValue);
      //         });
      this.updatedline1();
      this.updatedline2();
      this.updatedline3();
      this.updatedline4();
      this.updatedline5();
      //   }
      // });
    },
    updatedline1() {
      this.$http
        .post(`/api/bdVisitApply/listLiuShuiData`, {
          xtype: this.xtype,
          "xsize": "7",
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 0) {
            let xArr = [];
            let yArr = [];
            res.data.data.list.forEach((element) => {
              xArr.push(element.xValue);
              yArr.push(element.yValue);
            });
            this.setline1Echar1(xArr, yArr);
            this.setline1Echar3(xArr, yArr);
            let arr = [];

            xArr.forEach((element, index) => {
              let data = {
                name: xArr[index],
                value: yArr[index],
              };
              arr.push(data);
            });
            this.setline1Echar2(arr);
          }
        });
    },
    setline1Echar1(xArr, yArr) {
      let option = {
        xAxis: {
          data: xArr,
          axisLabel: {
            rotate: 30, // X轴标签倾斜 45 度
          },
        },
        yAxis: {
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
        },
        series: [
          {
            type: "bar", //形状为柱状图
            data: yArr,
          },
        ],
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      };
      this.$echarts.init(this.$refs.line1Echar1, "dark").setOption(option);
    },
    setline1Echar2(arr) {
      // let arr = [
      //   {
      //     name: "111",
      //     value: 10,
      //   },
      //   {
      //     name: "222",
      //     value: 50,
      //   },
      //   {
      //     name: "333",
      //     value: 50,
      //   },
      // ];
      let option = {
        grid: {
          top: "0",
          left: "10",
          right: "40",
          bottom: "0",
          containLabel: true,
        },
        title: {
          // text: '',
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["20%", "40%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ffffff",
              },
            },
          },
        ],
      };
      this.$echarts.init(this.$refs.line1Echar2, "dark").setOption(option);
    },

    setline1Echar3(xArr, yArr) {
      //   this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then((res) => {
      //     if (res.data.code == 0) {
      //   let xArr = [];
      //   let yArr = [];
      //   res.data.data.forEach((element) => {
      //     xArr.push(element.readingTime);
      //     yArr.push(element.positiveElec);
      //   });
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
            rotate: 30, // X轴标签倾斜
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 8,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // },
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.line1Echar3, "dark").setOption(option);
      //     }
      //   });
    },

    updatedline2() {
      let xArr = [];
      let yArr = [];
      if (this.xtype == "") {
        xArr = [
          "2024-06-18",
          "2024-06-19",
          "2024-06-20",
          "2024-06-21",
          "2024-06-22",
          "2024-06-23",

          "2024-06-24",
        ];
        yArr = [1582, 1132, 1201, 1134, 1320, 1283, 1282];
      }
      if (this.xtype == "month") {
        xArr = [
          "2023-12",
          "2024-01",
          "2024-02",
          "2024-03",
          "2024-04",
          "2024-05",
          "2024-06",
        ];
        yArr = [19782, 13832, 14901, 17934, 18320, 16283, 12282];
      }
      if (this.xtype == "year") {
        xArr = ["2022", "2023", "2024"];
        yArr = [153203, 162835, 82827];
      }
      this.setline2Echar1(xArr, yArr);
      this.setline2Echar3(xArr, yArr);
      let arr = [];

      xArr.forEach((element, index) => {
        let data = {
          name: xArr[index],
          value: yArr[index],
        };
        arr.push(data);
      });
      this.setline2Echar2(arr);
    },
    setline2Echar1(xArr, yArr) {
      let option = {
        xAxis: {
          data: xArr,
          axisLabel: {
            rotate: 30, // X轴标签倾斜 45 度
          },
        },
        yAxis: {
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
        },
        series: [
          {
            type: "bar", //形状为柱状图
            data: yArr,
          },
        ],
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      };
      this.$echarts.init(this.$refs.line2Echar1, "dark").setOption(option);
    },
    setline2Echar2(arr) {
      // let arr = [
      //   {
      //     name: "111",
      //     value: 10,
      //   },
      //   {
      //     name: "222",
      //     value: 50,
      //   },
      //   {
      //     name: "333",
      //     value: 50,
      //   },
      // ];
      let option = {
        grid: {
          top: "0",
          left: "10",
          right: "40",
          bottom: "0",
          containLabel: true,
        },
        title: {
          // text: '',
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["20%", "40%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ffffff",
              },
            },
          },
        ],
      };
      this.$echarts.init(this.$refs.line2Echar2, "dark").setOption(option);
    },

    setline2Echar3(xArr, yArr) {
      //   this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then((res) => {
      //     if (res.data.code == 0) {
      //   let xArr = [];
      //   let yArr = [];
      //   res.data.data.forEach((element) => {
      //     xArr.push(element.readingTime);
      //     yArr.push(element.positiveElec);
      //   });
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
            rotate: 30, // X轴标签倾斜
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 8,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // },
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.line2Echar3, "dark").setOption(option);
      //     }
      //   });
    },

    updatedline3() {
      this.$http
        .post(`/api/bdVisitApply/listData`, {
          xtype: this.xtype,
          "xsize": "7",
        })
        .then((res) => {
          if (res.data.code == 0) {
            let xArr = [];
            let yArr = [];
            res.data.data.list.forEach((element) => {
              xArr.push(element.xValue);
              yArr.push(element.yValue);
            });
            this.setline3Echar1(xArr, yArr);
            this.setline3Echar3(xArr, yArr);
            let arr = [];

            xArr.forEach((element, index) => {
              let data = {
                name: xArr[index],
                value: yArr[index],
              };
              arr.push(data);
            });
            this.setline3Echar2(arr);
          }
        });
    },
    setline3Echar1(xArr, yArr) {
      let option = {
        xAxis: {
          data: xArr,
          axisLabel: {
            rotate: 30, // X轴标签倾斜 45 度
          },
        },
        yAxis: {
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
        },
        series: [
          {
            type: "bar", //形状为柱状图
            data: yArr,
          },
        ],
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      };
      this.$echarts.init(this.$refs.line3Echar1, "dark").setOption(option);
    },
    setline3Echar2(arr) {
      // let arr = [
      //   {
      //     name: "111",
      //     value: 10,
      //   },
      //   {
      //     name: "222",
      //     value: 50,
      //   },
      //   {
      //     name: "333",
      //     value: 50,
      //   },
      // ];
      let option = {
        grid: {
          top: "0",
          left: "10",
          right: "40",
          bottom: "0",
          containLabel: true,
        },
        title: {
          // text: '',
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["20%", "40%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ffffff",
              },
            },
          },
        ],
      };
      this.$echarts.init(this.$refs.line3Echar2, "dark").setOption(option);
    },

    setline3Echar3(xArr, yArr) {
      //   this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then((res) => {
      //     if (res.data.code == 0) {
      //   let xArr = [];
      //   let yArr = [];
      //   res.data.data.forEach((element) => {
      //     xArr.push(element.readingTime);
      //     yArr.push(element.positiveElec);
      //   });
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
            rotate: 30, // X轴标签倾斜
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 8,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // },
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.line3Echar3, "dark").setOption(option);
      //     }
      //   });
    },

    updatedline4() {
      this.$http
        .post(`/api/bdVisitApply/listParkingData`, {
          xtype: this.xtype,
          "xsize": "7",
        })
        .then((res) => {
          if (res.data.code == 0) {
            let xArr = [];
            let yArr = [];
            res.data.data.list.forEach((element) => {
              xArr.push(element.xValue);
              yArr.push(element.yValue);
            });
            this.setline4Echar1(xArr, yArr);
            this.setline4Echar3(xArr, yArr);
            let arr = [];

            xArr.forEach((element, index) => {
              let data = {
                name: xArr[index],
                value: yArr[index],
              };
              arr.push(data);
            });
            this.setline4Echar2(arr);
          }
        });
    },
    setline4Echar1(xArr, yArr) {
      let option = {
        xAxis: {
          data: xArr,
          axisLabel: {
            rotate: 30, // X轴标签倾斜 45 度
          },
        },
        yAxis: {
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
        },
        series: [
          {
            type: "bar", //形状为柱状图
            data: yArr,
          },
        ],
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      };
      this.$echarts.init(this.$refs.line4Echar1, "dark").setOption(option);
    },
    setline4Echar2(arr) {
      // let arr = [
      //   {
      //     name: "111",
      //     value: 10,
      //   },
      //   {
      //     name: "222",
      //     value: 50,
      //   },
      //   {
      //     name: "333",
      //     value: 50,
      //   },
      // ];
      let option = {
        grid: {
          top: "0",
          left: "10",
          right: "40",
          bottom: "0",
          containLabel: true,
        },
        title: {
          // text: '',
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["20%", "40%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ffffff",
              },
            },
          },
        ],
      };
      this.$echarts.init(this.$refs.line4Echar2, "dark").setOption(option);
    },

    setline4Echar3(xArr, yArr) {
      //   this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then((res) => {
      //     if (res.data.code == 0) {
      //   let xArr = [];
      //   let yArr = [];
      //   res.data.data.forEach((element) => {
      //     xArr.push(element.readingTime);
      //     yArr.push(element.positiveElec);
      //   });
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
            rotate: 30, // X轴标签倾斜
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 8,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // },
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.line4Echar3, "dark").setOption(option);
      //     }
      //   });
    },

    updatedline5() {
      let xArr = [];
      let yArr = [];
      if (this.xtype == "") {
        xArr = [
          "2024-06-18",
          "2024-06-19",
          "2024-06-20",
          "2024-06-21",
          "2024-06-22",
          "2024-06-23",
          "2024-06-24",
        ];
        yArr = [2023, 1800, 1876, 1772, 2903, 3023, 682];
      }

      if (this.xtype == "month") {
        xArr = [
          "2023-12",
          "2024-01",
          "2024-02",
          "2024-03",
          "2024-04",
          "2024-05",
          "2024-06",
        ];
        yArr = [20233, 18004, 18765, 17721, 29032, 30234, 16827];
      }
      if (this.xtype == "year") {
        xArr = ["2022", "2023", "2024"];
        yArr = [290321, 302342, 208279];
      }
      this.setline5Echar1(xArr, yArr);
      this.setline5Echar3(xArr, yArr);
      let arr = [];

      xArr.forEach((element, index) => {
        let data = {
          name: xArr[index],
          value: yArr[index],
        };
        arr.push(data);
      });
      this.setline5Echar2(arr);
    },
    setline5Echar1(xArr, yArr) {
      let option = {
        xAxis: {
          data: xArr,
          axisLabel: {
            rotate: 30, // X轴标签倾斜 45 度
          },
        },
        yAxis: {
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
        },
        series: [
          {
            type: "bar", //形状为柱状图
            data: yArr,
          },
        ],
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      };
      this.$echarts.init(this.$refs.line5Echar1, "dark").setOption(option);
    },
    setline5Echar2(arr) {
      // let arr = [
      //   {
      //     name: "111",
      //     value: 10,
      //   },
      //   {
      //     name: "222",
      //     value: 50,
      //   },
      //   {
      //     name: "333",
      //     value: 50,
      //   },
      // ];
      let option = {
        grid: {
          top: "0",
          left: "10",
          right: "40",
          bottom: "0",
          containLabel: true,
        },
        title: {
          // text: '',
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "bottom",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["20%", "40%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "#ffffff",
              },
            },
          },
        ],
      };
      this.$echarts.init(this.$refs.line5Echar2, "dark").setOption(option);
    },

    setline5Echar3(xArr, yArr) {
      //   this.$http.get(`/api/energy/timePeriodEnergyConsumption`).then((res) => {
      //     if (res.data.code == 0) {
      //   let xArr = [];
      //   let yArr = [];
      //   res.data.data.forEach((element) => {
      //     xArr.push(element.readingTime);
      //     yArr.push(element.positiveElec);
      //   });
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
            rotate: 30, // X轴标签倾斜
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
            // formatter: "{value}人",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 8,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // },
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.line5Echar3, "dark").setOption(option);
      //     }
      //   });
    },

    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    Refresh() {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables.scss";

.energyData {
  //     width: 100vw;
  //   height: 100vh;
  background-color: #091631;
  // overflow: hidden;
  color: #d3d6dd;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow-x: hidden;
  overflow-y: auto;

  .bg {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  .host-body {
    padding: 10px 5px 0 5px;

    .dv-dec-10,
    .dv-dec-10-s {
      width: 33.3%;
      height: 5px;
    }

    .dv-dec-10-s {
      transform: rotateY(180deg);
    }

    .dv-dec-8 {
      width: 200px;
      height: 50px;
    }

    .title {
      position: relative;
      width: 500px;
      text-align: center;
      background-size: cover;
      background-repeat: no-repeat;

      .title-text {
        font-size: 28px;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%);
        color: #ffffff;
      }

      .dv-dec-6 {
        position: absolute;
        bottom: 10px;
        left: 50%;
        width: 250px;
        height: 8px;
        transform: translate(-50%);
      }
    }

    .line1Echar1,
    .line1Echar2,
    .line1Echar3,
    .line2Echar1,
    .line2Echar2,
    .line2Echar3,
    .line3Echar1,
    .line3Echar2,
    .line3Echar3,
    .line4Echar1,
    .line4Echar2,
    .line4Echar3,
    .line5Echar1,
    .line5Echar2,
    .line5Echar3 {
      height: 300px;
    }

    .title-text {
      font-size: 16px;
      color: #ffffff;
    }

    ::v-deep .el-progress__text {
      color: #ffffff !important;
    }

    ::v-deep .dv-scroll-ranking-board .ranking-info .rank {
      display: none;
    }

    .left1 {
      height: 94px;
      width: 100%;
      display: flex;

      .leftBC {
        background-color: #de4835;
        width: 50%;
        height: 100%;
        margin-left: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }

    .right1BC {
      background-color: #068b62;
      width: 50%;
      height: 100%;
      margin-left: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .right2BC {
      background-color: #0676be;
      width: 50%;
      height: 100%;
      margin-left: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .textCenter {
      width: 30px;
      color: black;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      writing-mode: vertical-rl;
    }

    .line1 {
      display: flex;
      justify-content: space-around;
      font-size: 17px;
      color: #ffffff;
      margin-top: 30px;
      font-weight: 450;

      .line1-item {
        display: flex;
        align-items: center;
        width: 31%;

        .line1-title {
          background-color: #1e4082;
          width: 150px;
          padding: 20px;
          display: flex;
          text-align: center;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }
        }

        .line1-right {
          display: flex;
          align-items: center;
          flex: 1;
          justify-content: space-around;
          text-align: center;
          height: 70px;
          background-color: #102658;

          .mun {
            color: #ff6600;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>
